import React, { useState , useEffect } from 'react';
import apiClient from '../apiClient';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useShop } from '../context/ShopContext';
import Sidebar from './Sidebar';
import "./responsiveTable.css";

const Creditdebit = () => {



  const [transactionType, setTransactionType] = useState('Credit');
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [amount, setAmount] = useState('');
  const [remark, setRemark] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // Button disable state
  const { userId, companyId, shopId } = useShop();
  const [crDrOptions, setCrDrOptions] = useState([]);
  const [selectedName, setSelectedName] = useState("");
  const [selectedCrDrId, setSelectedCrDrId] = useState("");
  const [selectedName1, setSelectedName1] = useState("");
  const [selectedCrDrId1, setSelectedCrDrId1] = useState("");
  const [crDrOptions1, setCrDrOptions1] = useState([]);






             const showToast = (message, type = "error") => {
                toast.dismiss(); // Dismiss any existing toast before showing a new one
              
                console.log("Toast Type:", type); // Debugging log to check type value
              
                if (type.toLowerCase() === "error") {
                  toast.error(message);
                } else if (type.toLowerCase() === "success") {
                  toast.success(message);
                } else {
                  console.warn("Invalid toast type:", type);
                }
              };
  

              const handleSubmit = async () => {
                if (!date || !amount || !remark || !selectedCrDrId || !selectedCrDrId1) {
                  showToast('Please fill in all fields!', "error");
                  return;
                }
              
                setIsSubmitting(true);
              
                const payload = {
                  shopId: shopId,
                  typeId: transactionType === 'Credit' ? 1 : 2,
                  amount: parseFloat(amount),
                  date: new Date(date).toISOString(),
                  remark: remark,
                 
                name: selectedName, 
                  crdrid: selectedCrDrId,
                  partnerId: selectedCrDrId1,
                };
                console.log("Credit payload:",payload)
              
                try {
                  const response = await apiClient.post(
                    '/Liquor/SaveAmount',
                    payload
                  );
              
                  const resData = response?.data;
                  console.log("Credit response:", resData);
              
                  if (response.status === 200) {
                    showToast(resData?.data || 'Data saved successfully.', "success");
                  } else {
                    showToast(resData?.data || 'Failed to submit transaction', "error"); 
                  }
                } catch (error) {
                  const errMsg = error.response?.data?.data || "Error submitting transaction";
                  showToast(errMsg, "error");
                }
              
                setIsSubmitting(false);
                setDate('');
                setAmount('');
                setRemark('');
                setName('');
              };
              





  const handleAmountChange = (e) => {
    const value = e.target.value;
    
    // Check if the entered value is negative
    if (value < 0) {
      showToast("Negative value is not allowed!","error");
      return;
    }
  
    setAmount(value);
  };
  





  useEffect(() => {
    const fetchCrDrNames = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetCrDrName',
          { companyId: companyId }
        );
  
        console.log("API Response:", response.data); // 👈 check this in dev tools
        const responseData = response.data;
  
        // Normalize if array is nested in a key like responseData.data
        const options = Array.isArray(responseData) 
          ? responseData 
          : Array.isArray(responseData.data) 
          ? responseData.data 
          : [];
  
        setCrDrOptions(options);
      } catch (error) {
        console.error("Error fetching Cr/Dr names:", error);
        setCrDrOptions([]); // fallback to empty array
      }
    };
  
    fetchCrDrNames();
  }, []);



   useEffect(() => {
    const fetchPartnerNames = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetPartnerData',
          {shopId:shopId , companyId: companyId}
        );
  
        console.log("API Response Partner dropdown:", response.data); // 👈 check this in dev tools
        const responseData = response.data;
  
        // Normalize if array is nested in a key like responseData.data
        const options = Array.isArray(responseData) 
          ? responseData 
          : Array.isArray(responseData.data) 
          ? responseData.data 
          : [];
  
        setCrDrOptions1(options);
      } catch (error) {
        console.error("Error fetching Partner names:", error);
        setCrDrOptions1([]); // fallback to empty array
      }
    };
  
    fetchPartnerNames();
  }, []);


  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
    {/* Content wrapper */}
    <div className="d-flex flex-column flex-column-fluid">
        {/* Toolbar */}
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            {/* Toolbar container */}
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                {/* Page title */}
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    {/* Title */}
                    <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                    Credit-Debit
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="index.html" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-500 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Dashboards</li>
                    </ul>
                </div>
            </div>
        </div>
  


























  
        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-xl-12">
                        <div className="card card-flush h-md-100">
                            <ToastContainer />
                          
                            <div className="card-body pt-6">
                                <div className="table-responsive">
                                    <div className="panel-body">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                         
                                        </div>
                                        <div className="clearfix"></div>
                                        <br />

      <div className="table-responsive h-400px entry-desktop" style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
  
      <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Transaction Type</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Remark</th>
                          <th>Name</th>
                          <th> Partner Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <select
                              value={transactionType}
                              onChange={(e) => setTransactionType(e.target.value)}
                              className="form-control"
                            >
                              <option value="Credit">Credit</option>
                              <option value="Debit">Debit</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control"
                              value={date}
                              max={new Date().toISOString().split("T")[0]}
                              onChange={(e) => setDate(e.target.value)}
                            />
                          </td>
                          <td>
                          <input
  type="text"
  value={amount}
  onChange={handleAmountChange}
  onKeyDown={(e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  }}
  onInput={(e) => {
    const val = e.target.value;
    if (val === "0") {
      e.target.value = "";
      showToast("Amount must be greater than 0", "error");
    }
  }}
  className="form-control"
  placeholder="Enter Amount"
  min="1"
/>

                          </td>
                          <td>
                            <input
                              type="text"
                              value={remark}
                              onChange={(e) => setRemark(e.target.value)}
                              className="form-control"
                              placeholder="Enter Remark"
                            />
                          </td>
                          <td>
                          <select
          className="form-control"
          value={selectedCrDrId}
          onChange={(e) => {
            const selected = crDrOptions.find(opt => opt.id === parseInt(e.target.value));
            setSelectedCrDrId(selected?.id || "");
            setSelectedName(selected?.name || "");
          }}
        >
          <option value="">Select Name</option>
          {crDrOptions.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
    </td>



                                 <td>
                          <select
          className="form-control"
          value={selectedCrDrId1}
          onChange={(e) => {
            const selected1 = crDrOptions1.find(opt => opt.id === parseInt(e.target.value));
            setSelectedCrDrId1(selected1?.id || "");
            setSelectedName1(selected1?.name || "");
          }}
        >
          <option value="">Select Name</option>
          {crDrOptions1.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
    </td>
                        </tr>
                      </tbody>
                    </table>

                   </div>

                                          {/* Mobile: single stacked form */}
                                          <div className="entry-mobile" style={{ marginBottom: 12 }}>
                                            <div className="ef-single-form">
                                              <div className="ef-field">
                                                <span className="ef-field-label">Transaction Type</span>
                                                <select
                                                  className="form-control"
                                                  value={transactionType}
                                                  onChange={(e) => setTransactionType(e.target.value)}
                                                >
                                                  <option value="Credit">Credit</option>
                                                  <option value="Debit">Debit</option>
                                                </select>
                                              </div>
                                              <div className="ef-field">
                                                <span className="ef-field-label">Date</span>
                                                <input
                                                  type="date"
                                                  className="form-control"
                                                  value={date}
                                                  max={new Date().toISOString().split("T")[0]}
                                                  onChange={(e) => setDate(e.target.value)}
                                                />
                                              </div>
                                              <div className="ef-field">
                                                <span className="ef-field-label">Amount</span>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={amount}
                                                  placeholder="Enter Amount"
                                                  min="1"
                                                  onChange={handleAmountChange}
                                                  onKeyDown={(e) => {
                                                    if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                                                  }}
                                                  onInput={(e) => {
                                                    if (e.target.value === "0") {
                                                      e.target.value = "";
                                                      showToast("Amount must be greater than 0", "error");
                                                    }
                                                  }}
                                                />
                                              </div>
                                              <div className="ef-field">
                                                <span className="ef-field-label">Remark</span>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={remark}
                                                  placeholder="Enter Remark"
                                                  onChange={(e) => setRemark(e.target.value)}
                                                />
                                              </div>
                                              <div className="ef-field">
                                                <span className="ef-field-label">Name</span>
                                                <select
                                                  className="form-control"
                                                  value={selectedCrDrId}
                                                  onChange={(e) => {
                                                    const selected = crDrOptions.find(opt => opt.id === parseInt(e.target.value));
                                                    setSelectedCrDrId(selected?.id || "");
                                                    setSelectedName(selected?.name || "");
                                                  }}
                                                >
                                                  <option value="">Select Name</option>
                                                  {crDrOptions.map((item) => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                  ))}
                                                </select>
                                              </div>
                                              <div className="ef-field">
                                                <span className="ef-field-label">Partner Name</span>
                                                <select
                                                  className="form-control"
                                                  value={selectedCrDrId1}
                                                  onChange={(e) => {
                                                    const selected1 = crDrOptions1.find(opt => opt.id === parseInt(e.target.value));
                                                    setSelectedCrDrId1(selected1?.id || "");
                                                    setSelectedName1(selected1?.name || "");
                                                  }}
                                                >
                                                  <option value="">Select Name</option>
                                                  {crDrOptions1.map((item) => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                  ))}
                                                </select>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="text-right align-items-right d-flex justify-content-end">

                                          <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={isSubmitting}   > {isSubmitting ? "Submitting..." : "Submit"}</button>

                                          </div>



                       
                         

 


                                          
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  
    {/* Footer */}
    <div id="kt_app_footer" className="app-footer">
        <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
            <div className="text-gray-900 order-2 order-md-1">
                <span className="text-muted fw-semibold me-1">2025&copy;</span>
                <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
            </div>
        </div>
    </div>

  
  
  
  
  
  
  

  
 
  
  
  
  
  
 
  

  
  </div>
  );
};

export default Creditdebit;
